import { Carrier } from './carrier';
import { LabMDM } from "../masterdata/models/lab";

export class CompleteScanRequest {
    carrier: Carrier;
    barCode: string;
    lab:LabMDM;
    
    constructor(carrier: Carrier, barcode:string, lab:LabMDM) {
        this.carrier = carrier;
        this.barCode = barcode;
        this.lab = lab;
    }
}

